<template>
  <div class="app-wrapper" :class="{hideSidebar:!sidebar.opened}">
    <div class="sidebar-wrapper" @mouseover="toggleSidebar()"  v-if="showLayout">
      <sidebar class="sidebar-container"></sidebar>
    </div>
    <div class="main-container">
      <navbar  v-if="showLayout"></navbar>
      <app-main></app-main>
    </div>
  </div>
</template>


<script>
import { Navbar, Sidebar, AppMain } from '@/views/layout'
import { agencyQnbarRequest } from '@/utils'

export default {
    name: 'layout',
    data: function() {
        return {
            showLayout:false
        }
    },
    components: {
        Navbar,
        Sidebar,
        AppMain
    },
    created() {
      this.getLeaseKeysNotify()
    },
    mounted:function () {
        var self = this;
        self.checkIsPhone();
    },
    computed: {
        sidebar() {
            return this.$store.state.app.sidebar
        }
    },
    methods: {
        checkIsPhone () {
            var self = this;
            if((navigator.userAgent.match(/(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
                self.showLayout = true;
                // $(".main-container").css("marginLeft","0");
            }else{
                self.showLayout = true;
            }
        },
        toggleSidebar() {
            if(!this.$store.state.app.sidebar.opened){
                // 修改vuex中silder_bar的值
                this.$store.commit('TOGGLE_SIDEBAR')
            }
        },
        leaseKeysAlert() {
          return agencyQnbarRequest('leaseKeysAlert')
        },
        getLeaseKeysNotify() {
          this.leaseKeysAlert()
            .then(res => {
              const infoList = res.data
              const h = this.$createElement;
              infoList.forEach(info => {
                const message = h('div', { style: 'margin: 0' }, [
                  h('p', { style: 'margin: 0' }, `门店：${ info.store_name }`),
                  h('p', { style: 'margin: 0' }, [
                    '可用密钥预计不足',
                    h('span', { style: 'color: red' }, ` ${info.days} `),
                    '天使用，请通知门店购买'
                  ])
                ])
                setTimeout(() => {
                  this.$notify.info({
                    title: '温馨提示',
                    message: message,
                    duration: 0
                  })
                }, 100) // 不用定时任务，显示会重叠，预计是计算高度时还未渲染完成
              })
            })
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    @import "src/styles/mixin.scss";
    .app-wrapper {
        @include clearfix;
        position: relative;
        height: 100%;
        width: 100%;
        &.hideSidebar {
            .sidebar-wrapper {
                transform: translate(-140px, 0);
                .sidebar-container {
                    transform: translate(132px, 0);
                }
                // &:hover {
                //     transform: translate(0, 0);
                //     .sidebar-container {
                //         transform: translate(0, 0);
                //     }
                // }
            }
            .main-container {
                margin-left: 40px;
            }
        }
        .sidebar-wrapper {
            width: 180px;
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            z-index: 1001;
            overflow: hidden;
            transition: all .28s ease-out;
        }
        .sidebar-container {
            transition: all .28s ease-out;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: -17px;
            overflow:hidden;
            overflow-y: scroll;
        }
        .main-container {
            min-height: 100%;
            transition: all .28s ease-out;
            margin-left: 180px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue?6be49090